import { apiFetch } from '../fetch';
import { IossReimportStatusModel } from '.';

export const iossReimportPreview = (): Promise<number> => apiFetch('/ioss/reimport/preview');

export const iossReimportStart = (): Promise<boolean> => apiFetch('/ioss/reimport/start');

export const iossReimportProgress = (): Promise<IossReimportStatusModel> => apiFetch('/ioss/reimport/progress');
